<template>
    <div class="footer bg-dark">
        <b-container>
            <b-row class="pt-5 pb-5">
                <b-col class="pt-4 pt-md-0 order-md-0 order-4" cols="12" md="3">
                    <b-button size="lg" href="email:opmbyjerry@proximus.be" class="text-light"> opmbyjerry@proximus.be</b-button>
                </b-col>
                <b-col class="al" cols="3" offset="1"  md="1" offset-md="2">
                    <a href="https://www.facebook.com/opmbyjerry" class="text-secondary fab fa-facebook-square"></a>
                </b-col>
                <b-col class="al" cols="4" md="1">
                    <a href="https://www.linkedin.com/in/jerry-jurez-8669a05b/" class="text-secondary fab fa-linkedin"></a>
                </b-col>
                <b-col class="al" cols="3" md="1">
                    <a href="https://www.instagram.com/explore/tags/opmbyjerry/" class="text-secondary fab fa-instagram"></a>
                </b-col>
                <b-col class="pt-4 pt-md-0 order-md-3 order-5" cols="12" md="3" offset-md="1">
                    <b-button size="lg" href="tel:+32476560830" class="text-light float-md-right">+32 476 56 08 30</b-button>>
                </b-col>
            </b-row>
        </b-container>
    </div>
</template>


<script>
    export default {
        name: 'Footer',
    }
</script>

<style>
    .footer .fab{
        font-size: 48px;
    }
</style>